// extracted by mini-css-extract-plugin
export default {"flexRow":"CopyToClipboard_flexRow__Rb9th","copyIcon":"CopyToClipboard_copyIcon__fjds3"};